import type { GaApp } from '~/modules/app'

export const getters = (gaApp: GaApp) => ({
  canSpin(): boolean {
    const hasEnoughCoinsForRoulette =
      gaApp.services.main.user.hasEnoughCoinsForRoulette()

    return gaApp.stores.main.user.data?.freeSpin || hasEnoughCoinsForRoulette
  },
})
